import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import MenuBar from './../components/Menubar';
import ProfileAvatar from "../components/ProfileAvatar";
import FindLocationHome from '../components/FindLocationHome';
import FacebookIconIMG from '../images/fb-logo.png';
import InstagramIconIMG from '../images/insta-logo.png';
import BurgersImage from '../images/new-burger.png';
import HandheldImage from '../images/handhelds.jpg';
import BreakfastImage from '../images/new-breakfast.png';
import EntreeImage from '../images/new-entree.png';
import DessertImage from '../images/pie.jpg';
import PizzaImage from '../images/new-pizza.png';
import AppsImage from '../images/new-appetizer.png';
import SidesImage from '../images/new-side.png';
import FastFoodImage from '../images/new-fast-food.png';

const DISTANCE_KEY = 'selectedDistance';

type Props = {
  user: any;
  location: any;
  handleLocationChange(obj): void;
};

const getInitialDistance = () => {
  const stored = localStorage.getItem(DISTANCE_KEY);
  return stored ? Number(stored) : 20;
};

const HomePage: React.FC<Props> = (props) => {
  const [showLocation, setShowLocation] = useState(false);
  const [selectedDistance, setSelectedDistance] = useState(getInitialDistance);

  console.log('current value for distance filter : ' + selectedDistance);

  const distances = [20, 10, 5, 1];
  const handlePlaceChanged = async (place: any) => {
    setShowLocation(false);
    props.handleLocationChange(place);
  };

  const handleHideLocation = async () => {
    setShowLocation(false);
  };

  const handleDistanceChange = (e) => {
    const value = Number(e.target.value);
    setSelectedDistance(value);
    localStorage.setItem(DISTANCE_KEY, String(value));
  };

  return (
    <main className="main-bg">
      <div className="home-container">
        <MenuBar user={props.user} />
        {props.user?.isLogged ? (
            <Link to="/my-page">
              <ProfileAvatar user={props.user} />
            </Link>
        ) : (
          <div className="logged-out-circle"></div>
        )}
        <section className="find-menu">
          <div className="row" style={{ marginTop: '-20px' }}>
            <div className="home-left-container">
              <h1 className="home-title">Yolomeal</h1>
              <p className="home-description">
                <span className="home-description-line">Discover dishes.</span>
                <span className="home-description-line home-description-line--second">Share favorites.</span>
                <span className="home-description-line home-description-line--third">Upvote the best.</span>
              </p>
            </div>

            <div className="home-right-container">
              <FindLocationHome
                location={props.location}
                handlePlaceChanged={handlePlaceChanged}
                handleClose={handleHideLocation}
              />

              <div
                className="distance-filter-row"
                style={{ margin: '20px 3px', display: 'flex', alignItems: 'center', gap: '20px' }}
              >
                <span className="distance-filter-label">Distance - mi</span>
                <div className="distance-checkbox-group">
                  {distances.map((distance) => (
                    <label className="distance-checkbox-label" key={distance}>
                      <input
                        type="checkbox"
                        value={distance}
                        checked={selectedDistance === distance}
                        onChange={handleDistanceChange}
                      />
                      <span className="distance-checkbox-custom">
                        <span className="x-mark">✗</span>
                      </span>
                      {distance}
                    </label>
                  ))}
                </div>
              </div>

              <div className="home-btn-action" style={{ marginTop: '40px', marginBottom: '20px' }}>
                <div className="home-btn-group">
                  <Link className="home-btn" to="/add-yolo">
                    Add Your Favorites
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Category Section */}
          <section className="category-section" style={{ marginTop: '6px', marginBottom: '30px' }}>
            <h1 className="category-title" style={{ marginBottom: '20px' }}>
              Choose Your Category
            </h1>

            <div className="category-grid white">
              {/* Row 1 */}
              <div className="food-box">
                <Link to="/entree">
                  <img className="category-img" src={EntreeImage} alt="entree" />
                  <h2>ENTREE</h2>
                </Link>
              </div>
              <div className="food-box">
                <Link to="/pizza">
                  <img className="category-img" src={PizzaImage} alt="pizza" />
                  <h2>PIZZA</h2>
                </Link>
              </div>
              <div className="food-box">
                <Link to="/burgers">
                  <img className="category-img" src={BurgersImage} alt="burgers" />
                  <h2>BURGERS</h2>
                </Link>
              </div>

              {/* Row 2 */}
              <div className="food-box">
                <Link to="/handheld">
                  <img className="category-img" src={HandheldImage} alt="handheld" />
                  <h2>HANDHELD</h2>
                </Link>
              </div>
              <div className="food-box">
                <Link to="/dessert">
                  <img className="category-img" src={DessertImage} alt="dessert" />
                  <h2>DESSERT</h2>
                </Link>
              </div>
              <div className="food-box">
                <Link to="/breakfast">
                  <img className="category-img" src={BreakfastImage} alt="breakfast" />
                  <h2>BREAKFAST</h2>
                </Link>
              </div>

              {/* Row 3 */}
              <div className="food-box">
                <Link to="/apps">
                  <img className="category-img" src={AppsImage} alt="apps" />
                  <h2>APPS</h2>
                </Link>
              </div>
              <div className="food-box">
                <Link to="/sides">
                  <img className="category-img" src={SidesImage} alt="sides" />
                  <h2>SIDES</h2>
                </Link>
              </div>
              <div className="food-box">
                <Link to="/fast-food">
                  <img className="category-img" src={FastFoodImage} alt="fast-food" />
                  <h2>FAST FOOD</h2>
                </Link>
              </div>
            </div>
          </section>
          <div className="home-food-ranking-container">
            <div className="home-food-ranking-title" />
            <div className="d-flex justify-content-end social-icon">
              <a href="https://www.facebook.com/profile.php?id=100070811767472">
                <img src={FacebookIconIMG} alt="facebook icon" width={48} height={48} />
              </a>
              <a href="https://www.instagram.com/yolo.meal/">
                <img src={InstagramIconIMG} alt="instgram icon" width={48} height={48} />
              </a>
            </div>
          </div>
        </section>
      </div>

      {/* <Modal isOpen={showLocation} ariaHideApp={false} style={customStyles}>
        <FindLocation location={props.location} handlePlaceChanged={handlePlaceChanged} handleClose={handleHideLocation} />
      </Modal> */}
    </main>
  );
};

export default HomePage;
